import React from "react";
import { ReactComponent as EditIcon } from "../../../images/icons/edit-alternative.svg";
import { ReactComponent as CircleIcon } from "../../../images/icons/circle.svg";
import { useLabOrderDetailsStore } from '../../../stores'

const ShowSeparateNotes = () => {
  const { isAdmin, notes, setActiveTab, setIsNotesModalOpen } = useLabOrderDetailsStore();

  const notesColor = [
    { label: 'Client Notes', class: '', name: 'client' },
    { label: 'Admin Notes', class: 'admin', name: 'admin' },
    { label: 'Boutique Notes', class: 'boutique', name: 'boutique' }
  ]

  const openEditModal = (noteType) => {
    setActiveTab(noteType);
    setIsNotesModalOpen(true);
  };

  return (
    <>
      <div className="w-layout-grid grid-38">
        {[0, 1, 2].map((_, idx) => {
          return (
            (isAdmin || idx != 1) &&
            <div className="div-block-143" key={idx}>
              <div className={`tab-link-tab-1-copy ${notesColor[idx]?.class || ""}`}>
                <div className="text-details-container">
                  <div className="icon smaller right-margin w-embed">
                    <CircleIcon />
                  </div>
                  <div>{notesColor[idx]?.label}</div>
                </div>
              </div>
              <div className="tab-pane-tab-2-copy">
                <div className="gray-block" style={{ minWidth: '280px', maxWidth: '280px' }}>
                  <p style={{ fontWeight: 'bold', color: 'red' }}>{notes[notesColor[idx]?.name]}</p>
                  {isAdmin && <div className="w-layout-grid grid-button-notes">
                    <button className="_2nd-button main smaller transparent w-inline-block"
                      onClick={(e) => {
                        e.preventDefault();
                        openEditModal(notesColor[idx]?.name);
                      }}
                    >
                      <div className="icon smaller right-margin w-embed">
                        <EditIcon />
                      </div>
                      <div>Add / Edit Note</div>
                    </button>
                  </div>}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>)
}

export default ShowSeparateNotes;